// extracted by mini-css-extract-plugin
module.exports = {"puck":"BackButton_puck__aLfFu","button":"BackButton_button__PAFJD"};